import type { Service, ServiceDomain } from './types';

export const formatType = (type: string) => (type ? type.replace(/\./g, ' ') : '');

export const stripProductPrefix = (name: string) =>
  name.replace(/^(WP|CP|cPanel|Managed WordPress)\s+/i, '');

export const formatDate = (dateString: string | null) => {
  if (!dateString || dateString === '0000-00-00') return '';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

export const getPrimaryDomain = (service: Service): ServiceDomain | undefined =>
  service.domains?.find((d) => d.is_primary);

export const sortServices = (items: Service[]): Service[] => {
  const suspended: Service[] = [];
  const noPrimary: Service[] = [];
  const hasPrimary: Service[] = [];

  items.forEach((item) => {
    if (item.is_suspended) {
      suspended.push(item);
    } else if (getPrimaryDomain(item)) {
      hasPrimary.push(item);
    } else {
      noPrimary.push(item);
    }
  });

  const sortByExpiryDesc = (a: Service, b: Service) => {
    const aDate = a.expiry_date ? new Date(a.expiry_date) : null;
    const bDate = b.expiry_date ? new Date(b.expiry_date) : null;
    if (aDate && bDate) {
      if (aDate > bDate) return -1;
      if (aDate < bDate) return 1;
    } else if (aDate) return -1;
    else if (bDate) return 1;
    return (a.common_name || '').localeCompare(b.common_name || '');
  };

  const sortByPrimaryDomainName = (a: Service, b: Service) => {
    const aDomain = getPrimaryDomain(a)?.domain_name || '';
    const bDomain = getPrimaryDomain(b)?.domain_name || '';
    if (!aDomain && bDomain) return 1;
    if (aDomain && !bDomain) return -1;
    return aDomain.localeCompare(bDomain);
  };

  suspended.sort(sortByExpiryDesc);
  noPrimary.sort(sortByExpiryDesc);
  hasPrimary.sort(sortByPrimaryDomainName);

  return [...suspended, ...noPrimary, ...hasPrimary];
};
